import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { take } from 'rxjs';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';
import { InventoryService } from 'src/app/services/inventory.service';
import { TemplateService } from 'src/app/services/template.service';

@Component({
  selector: 'app-item-webflow',
  templateUrl: './item-webflow.component.html',
  styleUrls: ['./item-webflow.component.scss']
})
export class ItemWebflowComponent implements OnInit {

  @Input() 
  public item: InventoryItem;

  @Input() 
  public data: any;

  public isLoading = false;

  constructor(
    private _ngZone: NgZone,
    private inventoryService: InventoryService,
    private templateService: TemplateService
  ) { }

  ngOnInit(): void {
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable.pipe(take(1)).subscribe(() => this.autosize.resizeToFitContent(true));
  }

  save() {
    this.item.lastModified = new Date();
    this.inventoryService.updateOne(this.item).subscribe(r => { });
  }

  // generateDefaults() {
  //   console.log(this.data)
  //   this.templateService.render(this.data.description, this.item).subscribe((r: any) => {
  //     this.item.facebook.description = r.render;

  //     this.templateService.render(this.data.title, this.item).subscribe((r: any) => {
  //       this.item.facebook.title = r.render;

  //       this.save();
  //     });
  //   });
  // }

}
